import React, { useState } from "react";
import "./Works.css";

const WorksCarousel = ({ images }) => {
  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="carousel">
      <img src={images[index]} alt="work" className="carousel-img" />

      <button className="carousel-btn left" onClick={prevSlide}>
        ❮
      </button>

      <button className="carousel-btn right" onClick={nextSlide}>
        ❯
      </button>
    </div>
  );
};

export default WorksCarousel;